import styled from 'styled-components';
import { spaceOptions } from './utils';

const bodyFont = 'Source Sans Pro';

export const Breadcrumbs = styled.ul`
    list-style: none;
    padding: 0;
    margin: 15px 0;
    >li+li:before {
      content: '→';
      padding: 0 5px;
      color: ${props => props.theme.muted};
      text-decoration: none;
    }  
    li {
      font-size: 14px;
      font-family: '${bodyFont}';
      color: #7B7C7E;
      display: inline-block;
      a {
        color: #7B7C7E;
        text-decoration: none;
        &:hover {
          color: ${props => props.theme.dark};
          text-decoration: underline;
        }
      }
    }
   ${spaceOptions}
`;
Breadcrumbs.displayName = 'Breadcrumbs';
